import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", null, [
    (_ctx.display && _ctx.needsConfirm)
      ? _renderSlot(_ctx.$slots, "default", {
          key: 0,
          confirm: _ctx.confirmData,
          needsConfirm: _ctx.needsConfirm
        }, () => [
          _createTextVNode(_toDisplayString(_ctx.message), 1)
        ])
      : _createCommentVNode("", true)
  ]))
}